module.exports = __webpack_public_path__ + "img/bottom_icon_my.77138480.svg";